import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import './style.css'
import Home from './views/home'
import Wallpapers from './views/Wallpapers'
import NotFound from './views/not-found'
import career from './views/career'
const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/wallpapers" component={Wallpapers} />
        <Route exact path="/careers" component={career} />
        <Route component={NotFound} />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
